import { create } from 'zustand';
export var useTuiServiceStore = create(function (set, get) { return ({
    elementMap: new Map(),
    activeSequence: undefined,
    disabled: false,
    updateTuiTargetElementData: function (elementId, data) {
        if (!get().disabled) {
            set(function (state) { return ({
                elementMap: new Map(state.elementMap).set(elementId, data),
            }); });
        }
    },
    setActiveTeachingSequence: function (callouts, markSequenceAsSeenFn, startingIndex, shouldUpdateNewUserState) {
        if (startingIndex === void 0) { startingIndex = 0; }
        if (shouldUpdateNewUserState === void 0) { shouldUpdateNewUserState = false; }
        set(function () { return ({
            activeSequence: {
                callouts: callouts,
                markSequenceAsSeenFn: markSequenceAsSeenFn,
                startingIndex: startingIndex,
                shouldUpdateNewUserState: shouldUpdateNewUserState,
            },
        }); });
    },
    clearActiveTeachingSequence: function () { return set({ activeSequence: undefined }); },
    // Add param to setDisabled to allow for re-enabling if we need TUIs to be able to be displayed
    // after the initial run
    setDisabled: function () {
        return set({
            disabled: true,
            activeSequence: undefined,
            elementMap: new Map(),
        });
    },
}); });
//# sourceMappingURL=store.js.map